<template>
  <div class="detail">
    <div class="container">
      <h3 class="detail-title">
        <span>TF-RLs Details</span>
        <span class="detail-update-time">
          Last update:
          {{
            detail.updateTime
              ? dayjs(detail.updateTime).format("YYYY-MM-DD")
              : "-"
          }}
        </span>
      </h3>
      <div class="detail-main">
        <h3 class="detail-title">Basic information</h3>
        <div class="detail-desc">
          <div
            v-for="item in baseInfo"
            :key="item.label"
            class="detail-desc__item"
          >
            <b class="detail-desc__label"> {{ `${item.label}:` }} </b>
            <div v-if="!item.isLink" class="detail-desc__value">
              {{ item.value }}
            </div>
            <a v-else :href="item.value" target="_blank">{{ item.value }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cofRetrieveDataBasedOnID } from "@/api/detail";
import dayjs from "dayjs";

export default {
  name: "CofDetailView",
  computed: {
    dayjs() {
      return dayjs;
    },
  },
  mounted() {
    this.initData();
  },
  data() {
    return {
      detail: {
        updateTime: null,
      },
      baseInfo: [
        {
          label: "TF",
          value: "",
          isLink: false,
        },
        {
          label: "TF-RLs Name",
          value: "",
          isLink: false,
        },
        {
          label: "Species",
          value: "",
          isLink: false,
        },
        {
          label: "Fomula",
          value: "",
          isLink: false,
        },
        {
          label: "External Id",
          value: "",
          isLink: false,
        },
        {
          label: "External Id Hyper Link",
          value: "",
          isLink: false,
        },
        {
          label: "Pubchem Cid",
          value: "",
          isLink: false,
        },
        {
          label: "Pubchem Cid Hyper Link",
          value: "",
          isLink: false,
        },
        {
          label: "Pubchem Sid",
          value: "",
          isLink: false,
        },
        {
          label: "Pubchem Sid Hyper Link",
          value: "",
          isLink: false,
        },
        {
          label: "Molecular Weight",
          value: "",
          isLink: false,
        },
        {
          label: "Source",
          value: "",
          isLink: false,
        },
        {
          label: "Score",
          value: "",
          isLink: false,
        },
      ],
    };
  },
  methods: {
    initData() {
      const id = this.$route.query.id || "";
      cofRetrieveDataBasedOnID(id).then((res) => {
        const store = res.data;
        this.detail = store;
        this.baseInfo = [
          {
            label: "TF",
            value: store.tfName,
            isLink: false,
          },
          {
            label: "TF-RLs Name",
            value: store.tfCofName,
            isLink: false,
          },
          {
            label: "Species",
            value: store.species,
            isLink: false,
          },
          {
            label: "Fomula",
            value: store.fomula,
            isLink: false,
          },
          {
            label: "External Id",
            value: store.externalId,
            isLink: false,
          },
          {
            label: "External Id Hyper Link",
            value: store.externalIdHyperlink,
            isLink: true,
          },
          {
            label: "Pubchem Cid",
            value: store.pubchemCid,
            isLink: false,
          },
          {
            label: "Pubchem Cid Hyper Link",
            value: store.pubchemCidHyperlink,
            isLink: true,
          },
          {
            label: "Pubchem Sid",
            value: store.pubchemSid,
            isLink: false,
          },
          {
            label: "Pubchem Sid Hyper Link",
            value: store.pubchemSidHyperlink,
            isLink: true,
          },
          {
            label: "Molecular Weight",
            value: store.molecularWeight,
            isLink: false,
          },
          {
            label: "Source",
            value: store.source,
            isLink: false,
          },
          {
            label: "Score",
            value: store.score,
            isLink: false,
          },
        ];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  padding: px2rem(20) 0;

  .detail-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: px2rem(20);
    font-weight: bold;
    color: #fff;
    background-color: $--color-primary;
    padding: px2rem(20);
    border-radius: px2rem(6);
    margin-bottom: px2rem(20);
  }

  .detail-update-time {
    font-size: px2rem(16);
  }

  .detail-main {
    padding: px2rem(20);

    .detail-title {
      background-color: $--color-secondary;
    }

    .detail-desc {
      padding: 0 20px;
      display: grid;
      grid-template-columns: 1fr 1.2fr;
      font-size: px2rem(16);
      line-height: 2.5;
      margin-bottom: px2rem(30);
    }

    .detail-desc__item {
      display: flex;

      a {
        color: $--color-primary;

        &:hover {
          text-decoration: underline;
        }

        &:visited {
          color: $--color-primary-light-6;
        }
      }
    }

    .detail-desc__label {
      margin-right: px2rem(6);
    }

    .detail-desc__value {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
